export const RepeatIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2365_1127)">
      <path d="M4.66667 4.66671L11.3333 4.66671V6.66671L14 4.00004L11.3333 1.33337V3.33337L3.33333 3.33337L3.33333 7.33337H4.66667L4.66667 4.66671ZM11.3333 11.3334L4.66667 11.3334V9.33337L2 12L4.66667 14.6667V12.6667L12.6667 12.6667V8.66671H11.3333V11.3334Z" />
    </g>
    <defs>
      <clipPath id="clip0_2365_1127">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
